import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import { API_GET_ACTIVITY_LOG, API_GET_DOCUMENT_LIST, API_GET_DOCUMENT_SIGNED_URL, API_GET_DOCUMENTS } from "../../../shared/routes/private.routes";
const config = {
    name: "activity-log",
  };

  // `documents/list` paginates with a default page size of 10; the drawers show
  // every attachment for a record, so ask for a page big enough to cover that.
  const DOCUMENT_LIST_LIMIT = 200;
  
  export const getActivityLogs: any = createAsyncThunk(
    `${config.name}/get-activity-logs`,
    async (id: string) => {
      return Client.get(API_GET_ACTIVITY_LOG+`${id}`);
    }
  );

  // All documents belonging to a parent record, regardless of document type.
  // `documents/get-document-list/:staffId` cannot be used here: it requires a
  // `documentTypeId` and validates the id against the staff table, so it 404s
  // for the create/edit drawers (which want every document for staff, accounts,
  // vendors and projects alike).
  export const getDocuments: any = createAsyncThunk(
    `${config.name}/get-documents`,
    async (id: string) => {
      const result = await Client.get(API_GET_DOCUMENT_LIST, {
        params: { parentId: id, limit: DOCUMENT_LIST_LIMIT },
      });
      return result?.data
    }
  );

  export const getSignedUrl: any = createAsyncThunk(
    `${config.name}/get-signed-url`,
    async ({module,params}:{module: string,params:any}) => {
      return Client.get(API_GET_DOCUMENT_SIGNED_URL+`${module}`,{params});
    }
  );

  export const activityLogReducer = createSlice({
    name: config.name,
    initialState: {},
    reducers: {}
  })

  export default activityLogReducer.reducer;